module.exports = __webpack_public_path__ + "img/[尴尬].5f53ebf9.svg";